export const ENV = {
  production: !(window.location.hostname === 'localhost')
}
